import { render, staticRenderFns } from "./PayData.vue?vue&type=template&id=e2c38c26&scoped=true"
import script from "./PayData.vue?vue&type=script&lang=js"
export * from "./PayData.vue?vue&type=script&lang=js"
import style0 from "./PayData.vue?vue&type=style&index=0&id=e2c38c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c38c26",
  null
  
)

export default component.exports